import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  Divider,
  Grid,
  IconButton,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  CancelOutlined,
  CheckCircleOutline,
  Close,
  Groups2Outlined,
} from "@mui/icons-material";
import noImage from "../../assets/img/no_image0.jpeg";
import PlusOrMinusButton from "../../components/PlusOrMinusButton";
import { paxLabel, toActivityLines as toLines } from "../../utils";

function Activities({ activities, setPage, colors, selectedActivities, setselectedActivities }) {
  const [detailsActivity, setDetailsActivity] = useState(null);

  const handleActivitySelection = (value, index) => {
    let arr = activities;
    const minPax = arr[index].minimum_pax || 1;
    arr[index].count = value;
    arr[index].billedCount = value ? Math.max(value, minPax) : 0;
    let filtered = arr.filter((e) => e.count && e.count !== 0);
    setselectedActivities(filtered);
  };

  const getCount = (id) => selectedActivities?.find((e) => e._id === id)?.count || 0;
  const getBilledPax = (activity) => {
    const count = getCount(activity._id);
    return count ? Math.max(count, activity.minimum_pax || 1) : 0;
  };

  const handleNextButton = () => setPage(3.1);

  return (
    <Stack justifyContent="start" alignItems="center">
      <Grid container justifyContent="center" mt={2} mb={5}>
        <Grid item md={12} xs={12}>
          <Stack
            p={{ xs: 2, md: 3 }}
            bgcolor={"rgb(0, 0, 0, 0.7)"}
            style={{ backdropFilter: `blur(5px)` }}
            borderRadius={2}
          >
            <Stack mb={2}>
              <Typography fontSize={24} fontWeight={700}>
                Enhance Your Stay
              </Typography>
              <Typography fontSize={14} color={"#bbb"}>
                Optional experiences you can add to make your stay memorable.
              </Typography>
            </Stack>

            <Grid container spacing={2}>
              {activities.map((activity, index) => {
                const minPax = activity.minimum_pax || 1;
                const maxPax = activity.maximum_pax || 0;
                const rate = parseFloat(activity?.rate || 0);
                const billed = getBilledPax(activity);
                return (
                  <Grid item xs={12} sm={6} md={4} key={activity._id}>
                    <Stack bgcolor={colors.primary[400]} borderRadius={2} height="100%" overflow="hidden">
                      <img
                        src={activity.img || `${noImage}?w=164&h=164&fit=crop&auto=format`}
                        alt=""
                        width="100%"
                        height="170px"
                        style={{ objectFit: "cover" }}
                      />
                      <Stack p={2} spacing={0.75} flexGrow={1}>
                        <Typography fontWeight={600} fontSize={18} lineHeight={1.2}>
                          {activity.name}
                        </Typography>

                        <Chip
                          icon={<Groups2Outlined sx={{ fontSize: 16 }} />}
                          label={paxLabel(minPax, maxPax)}
                          size="small"
                          variant="outlined"
                          sx={{
                            alignSelf: "flex-start",
                            fontWeight: minPax > 1 ? 600 : 400,
                            color: minPax > 1 ? colors.greenAccent[400] : "#ddd",
                            borderColor: minPax > 1 ? colors.greenAccent[500] : "rgba(255,255,255,0.25)",
                            "& .MuiChip-icon": { color: colors.greenAccent[400] },
                          }}
                        />

                        <Typography
                          color={"#ccc"}
                          fontSize={14}
                          sx={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                        >
                          {activity.description || "-"}
                        </Typography>

                        {(activity.description || activity.inclusions || activity.exclusions) ? (
                          <Link
                            component="button"
                            type="button"
                            underline="hover"
                            textAlign="left"
                            fontSize={13}
                            onClick={() => setDetailsActivity(activity)}
                            sx={{ width: "fit-content", color: colors.greenAccent[400] }}
                          >
                            View details
                          </Link>
                        ) : null}

                        <Stack
                          mt="auto"
                          pt={1.5}
                          direction="row"
                          alignItems="end"
                          justifyContent="space-between"
                          spacing={2}
                        >
                          <PlusOrMinusButton
                            min={0}
                            max={maxPax > 0 ? maxPax : 20}
                            jumpMin={minPax}
                            name="activityCount"
                            value={0}
                            handleChange={(value) => handleActivitySelection(value, index)}
                          />
                          <Stack textAlign="end" minWidth={"45%"}>
                            <Typography fontWeight={600} fontSize={16} noWrap>
                              ₹{rate.toFixed(2)}
                            </Typography>
                            <Typography fontSize={12} color={"#aaa"}>
                              per person
                            </Typography>
                            {billed ? (
                              <>
                                <Typography mt={0.5} color="primary" fontWeight={600} fontSize={15} noWrap>
                                  ₹{(rate * billed).toFixed(2)}
                                  <span style={{ color: "#aaa", fontWeight: 400, fontSize: 12 }}>
                                    {" "}
                                    ({billed} pax)
                                  </span>
                                </Typography>
                                {minPax > 1 && billed === minPax ? (
                                  <Typography fontSize={11} color={colors.greenAccent[400]}>
                                    Rate calculated based on the minimum guest requirement.
                                  </Typography>
                                ) : null}
                              </>
                            ) : null}
                          </Stack>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Grid>
                );
              })}
              {!activities.length ? (
                <Grid item xs={12}>
                  <Stack p={2} pt={10} pb={10} textAlign={"center"}>
                    {" "}
                    No data found!{" "}
                  </Stack>
                </Grid>
              ) : null}
              <Grid item xs={12}>
                <Stack mt={2} spacing={2} direction="row" justifyContent="end">
                  {!selectedActivities?.length ? (
                    <Button variant="outlined" onClick={handleNextButton}>
                      <b>Skip</b>
                    </Button>
                  ) : null}
                  <Button
                    type="submit"
                    color="secondary"
                    variant="contained"
                    sx={{ fontSize: "15px" }}
                    disabled={!selectedActivities.length}
                    onClick={handleNextButton}
                  >
                    <b>Add Selected Services</b>
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Stack>
        </Grid>
      </Grid>

      <ActivityDetailsDialog
        activity={detailsActivity}
        colors={colors}
        billedPax={detailsActivity ? getBilledPax(detailsActivity) : 0}
        onClose={() => setDetailsActivity(null)}
      />
    </Stack>
  );
}

function ActivityDetailsDialog({ activity, colors, billedPax, onClose }) {
  const minPax = activity?.minimum_pax || 1;
  const maxPax = activity?.maximum_pax || 0;
  const rate = parseFloat(activity?.rate || 0);
  const inclusions = toLines(activity?.inclusions);
  const exclusions = toLines(activity?.exclusions);

  return (
    <Dialog
      open={!!activity}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { bgcolor: colors.primary[400], backgroundImage: "none", borderRadius: 2 },
      }}
    >
      {activity ? (
        <>
          <Box position="relative">
            <img
              src={activity.img || `${noImage}?w=164&h=164&fit=crop&auto=format`}
              alt=""
              width="100%"
              height="240px"
              style={{ objectFit: "cover", display: "block" }}
            />
            <IconButton
              onClick={onClose}
              size="small"
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                bgcolor: "rgba(0,0,0,0.55)",
                color: "#fff",
                "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
              }}
            >
              <Close fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ p: 3 }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              spacing={2}
            >
              <Box>
                <Typography variant="h5" fontWeight={700}>
                  {activity.name}
                </Typography>
                <Chip
                  icon={<Groups2Outlined sx={{ fontSize: 16 }} />}
                  label={paxLabel(minPax, maxPax)}
                  size="small"
                  variant="outlined"
                  sx={{
                    mt: 1,
                    color: "#ddd",
                    borderColor: "rgba(255,255,255,0.25)",
                    "& .MuiChip-icon": { color: colors.greenAccent[400] },
                  }}
                />
              </Box>
              <Box textAlign="right">
                <Typography fontWeight={700} fontSize={20} noWrap>
                  ₹{rate.toFixed(2)}
                </Typography>
                <Typography fontSize={12} color={"#aaa"}>
                  per person
                </Typography>
              </Box>
            </Stack>

            {minPax > 1 ? (
              <Typography mt={1} fontSize={13} color={colors.greenAccent[400]}>
                Priced for a minimum of {minPax} guests.
              </Typography>
            ) : null}

            {activity.description ? (
              <Typography mt={2} color={"#ccc"} sx={{ whiteSpace: "pre-line" }}>
                {activity.description}
              </Typography>
            ) : null}

            {inclusions.length || exclusions.length ? (
              <Divider sx={{ my: 2.5, borderColor: "rgba(255,255,255,0.12)" }} />
            ) : null}

            {inclusions.length ? (
              <Box mb={exclusions.length ? 2 : 0}>
                <Typography variant="caption" sx={{ letterSpacing: 1 }} color={"#aaa"}>
                  WHAT'S INCLUDED
                </Typography>
                <Stack spacing={1} mt={1}>
                  {inclusions.map((line, i) => (
                    <Stack key={i} direction="row" spacing={1.5} alignItems="flex-start">
                      <CheckCircleOutline sx={{ fontSize: 18, mt: "2px", color: colors.greenAccent[400] }} />
                      <Typography fontSize={14} color={"#ddd"}>{line}</Typography>
                    </Stack>
                  ))}
                </Stack>
              </Box>
            ) : null}

            {exclusions.length ? (
              <Box>
                <Typography variant="caption" sx={{ letterSpacing: 1 }} color={"#aaa"}>
                  WHAT'S NOT INCLUDED
                </Typography>
                <Stack spacing={1} mt={1}>
                  {exclusions.map((line, i) => (
                    <Stack key={i} direction="row" spacing={1.5} alignItems="flex-start">
                      <CancelOutlined sx={{ fontSize: 18, mt: "2px", color: colors.redAccent[400] }} />
                      <Typography fontSize={14} color={"#ddd"}>{line}</Typography>
                    </Stack>
                  ))}
                </Stack>
              </Box>
            ) : null}

            {billedPax ? (
              <>
                <Divider sx={{ my: 2.5, borderColor: "rgba(255,255,255,0.12)" }} />
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography color={"#bbb"} fontSize={14}>
                    Added — {billedPax} pax
                  </Typography>
                  <Typography fontWeight={700} fontSize={18} color="primary">
                    ₹{(rate * billedPax).toFixed(2)}
                  </Typography>
                </Stack>
              </>
            ) : null}
          </DialogContent>
        </>
      ) : null}
    </Dialog>
  );
}

export default Activities;
